import type { ConstValues } from '@openx/types/helpers';
export const FileExtension = {
  CSV: 'csv',
} as const;
export type FileExtensionValues = ConstValues<typeof FileExtension>;

export const FileExtensionMimeType = {
  CSV: 'text/csv',
  ApplicationJavascript: 'application/javascript',
} as const;
export type FileExtensionMimeTypeValues = ConstValues<typeof FileExtensionMimeType>;
